const questions: Record<string, PolicyFormQuestion> = {
  clientGender: {
    id: 'client-gender',
    questionRef: 'clientGender',
    title: 'Gender',
    type: 'select',
    required: true,
    options: [
      { id: 'male', value: 'Male' },
      { id: 'female', value: 'Female' },
    ],
  },
  clientAge: {
    id: 'client-age',
    questionRef: 'clientAge',
    title: 'Age',
    type: 'number',
    required: true,
  },
  clientHeight: {
    id: 'client-height',
    questionRef: 'clientHeight',
    title: 'Height',
    type: 'text',
    required: true,
  },
  clientWeight: {
    id: 'client-weight',
    questionRef: 'clientWeight',
    title: 'Weight',
    type: 'number',
    required: true,
  },
  productsUsed: {
    id: 'products-used',
    questionRef: 'productsUsed',
    title: 'Products Used (last 12 mos)',
    type: 'multiselect',
    options: [
      { id: 'tobacco', value: 'Tobacco' },
      { id: 'nicotine-products', value: 'Nicotine Products' },
      { id: 'marijuana', value: 'Marijuana' },
    ],
  },
  productsUseFrequency: {
    id: 'products-use-frequency',
    questionRef: 'productsUseFrequency',
    title: 'Frequency of Use',
    type: 'text',
  },
  productsUseAmount: {
    id: 'products-use-amount',
    questionRef: 'productsUseAmount',
    title: 'Amount of Use',
    type: 'text',
  },
  pendingSurgery: {
    id: 'pending-surgery',
    questionRef: 'pendingSurgery',
    title: 'Any surgery / testing / treatment pending?',
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  pendingSurgeryDetails: {
    id: 'pending-surgery-details',
    questionRef: 'pendingSurgeryDetails',
    title: 'If Yes, provide details',
    type: 'textarea',
  },
  previouslyDeclined: {
    id: 'previously-declined',
    questionRef: 'previouslyDeclined',
    title: 'Previously declined by another company',
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  socialSecurityDisability: {
    id: 'social-security-disability',
    questionRef: 'socialSecurityDisability',
    title: 'Currently / previously receive Social Security disability benefits',
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  cardiacDiagnosis: {
    id: 'cardiac-diagnosis',
    questionRef: 'cardiacDiagnosis',
    title: 'Cardiac Diagnosis',
    type: 'text',
  },
  cardiacDateDiagnosed: {
    id: 'cardiac-date-diagnosed',
    questionRef: 'cardiacDateDiagnosed',
    title: 'Cardiac Date Diagnosed (mm/yyyy)',
    type: 'date',
  },
  cardiacRecentTestingResults: {
    id: 'cardiac-recent-testing-results',
    questionRef: 'cardiacRecentTestingResults',
    title: 'Dates & results of most recent EKG / cath / echo / stress test',
    type: 'textarea',
  },
  cardiacCurrentSymptoms: {
    id: 'cardiac-current-symptoms',
    questionRef: 'cardiacCurrentSymptoms',
    title: 'Current blockages or symptoms',
    type: 'textarea',
  },
  cardiacAdditionalConditions: {
    id: 'cardiac-additional-conditions',
    questionRef: 'cardiacAdditionalConditions',
    title: 'Check all cardiac-related conditions that apply',
    type: 'multiselect',
    options: [
      { id: 'stroke', value: 'Stroke' },
      { id: 'tia', value: 'TIA' },
      { id: 'diabetes', value: 'Diabetes' },
      {
        id: 'peripheral-vascular-disease',
        value: 'Peripheral Vascular Disease',
      },
      { id: 'cardiomyopathy', value: 'Cardiomyopathy' },
      {
        id: 'congestive-heart-failure',
        value: 'Congestive Heart Failure',
      },
      { id: 'heart-other', value: 'Other Heart Condition' },
    ],
  },
  cardiacDatesDetails: {
    id: 'cardiac-dates-details',
    questionRef: 'cardiacDatesDetails',
    title: 'Cardiac – dates & details',
    type: 'textarea',
  },
  afibTreatments: {
    id: 'afib-treatments',
    questionRef: 'afibTreatments',
    title: 'A-Fib – treatment(s)',
    type: 'multiselect',
    options: [
      { id: 'medication', value: 'Medication' },
      { id: 'ablation', value: 'Ablation' },
      { id: 'cardioversion', value: 'Cardioversion' },
      { id: 'pacemaker', value: 'Pacemaker' },
      { id: 'defibrillator', value: 'Defibrillator' },
    ],
  },
  afibDetails: {
    id: 'afib-details',
    questionRef: 'afibDetails',
    title: 'A-Fib – dates / medications / details',
    type: 'textarea',
  },
  cadTreatments: {
    id: 'cad-treatments',
    questionRef: 'cadTreatments',
    title: 'CAD – treatment(s)',
    type: 'multiselect',
    options: [
      { id: 'medication', value: 'Medication' },
      { id: 'angioplasty', value: 'Angioplasty' },
      { id: 'stenting', value: 'Stenting' },
      { id: 'bypass-surgery', value: 'Bypass Surgery' },
      { id: 'other-heart-surgery', value: 'Other Heart Surgery' },
      {
        id: 'left-main-involvement',
        value: 'Left Main Involvement',
      },
    ],
  },
  cadHistoryHeartAttack: {
    id: 'cad-history-heart-attack',
    questionRef: 'cadHistoryHeartAttack',
    title: 'History of heart attack',
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  cadDetails: {
    id: 'cad-details',
    questionRef: 'cadDetails',
    title: 'CAD – dates / meds / vessels / stents / bypass details',
    type: 'textarea',
  },
  vhdValves: {
    id: 'vhd-valves',
    questionRef: 'vhdValves',
    title: 'Valvular HD – which valve(s)',
    type: 'text',
  },
  vhdTreatments: {
    id: 'vhd-treatments',
    questionRef: 'vhdTreatments',
    title: 'Valvular HD – treatment(s)',
    type: 'multiselect',
    options: [
      { id: 'medication', value: 'Medication' },
      { id: 'surgery', value: 'Surgery / Valve Replacement' },
    ],
  },
  vhdDetails: {
    id: 'vhd-details',
    questionRef: 'vhdDetails',
    title: 'Valvular HD – dates & details',
    type: 'textarea',
  },
  cancerDiagnosisLocation: {
    id: 'cancer-diagnosis-location',
    questionRef: 'cancerDiagnosisLocation',
    title: 'Cancer – diagnosis & location',
    type: 'text',
  },
  cancerDateDiagnosed: {
    id: 'cancer-date-diagnosed',
    questionRef: 'cancerDateDiagnosed',
    title: 'Cancer – date diagnosed (mm/yyyy)',
    type: 'date',
  },
  cancerStageGradeType: {
    id: 'cancer-stage-grade-type',
    questionRef: 'cancerStageGradeType',
    title: 'Cancer – stage / grade / type',
    type: 'text',
  },
  cancerTumorSize: {
    id: 'cancer-tumor-size',
    questionRef: 'cancerTumorSize',
    title: 'Tumor size',
    type: 'text',
  },
  cancerLymphNodeSpread: {
    id: 'cancer-lymph-node-spread',
    questionRef: 'cancerLymphNodeSpread',
    title: 'Lymph-node involvement / spread',
    type: 'textarea',
  },
  cancerTreatments: {
    id: 'cancer-treatments',
    questionRef: 'cancerTreatments',
    title: 'Cancer treatment(s)',
    type: 'multiselect',
    options: [
      { id: 'surgery', value: 'Surgery' },
      { id: 'chemo', value: 'Chemo' },
      { id: 'radiation', value: 'Radiation' },
      { id: 'other', value: 'Other' },
    ],
  },
  cancerDateLastTreated: {
    id: 'cancer-date-last-treated',
    questionRef: 'cancerDateLastTreated',
    title: 'Date last treated (mm/yyyy)',
    type: 'date',
  },
  cancerRecurrence: {
    id: 'cancer-recurrence',
    questionRef: 'cancerRecurrence',
    title: 'Any recurrence / other cancer',
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  cancerRecurrenceDetails: {
    id: 'cancer-recurrence-details',
    questionRef: 'cancerRecurrenceDetails',
    title: 'If Yes, provide recurrence details',
    type: 'textarea',
  },
  breastCancerType: {
    id: 'breast-cancer-type',
    questionRef: 'breastCancerType',
    title: 'Breast Cancer – Select Type',
    type: 'select',
    options: [
      { id: 'ductal', value: 'Ductal' },
      { id: 'lobular', value: 'Lobular' },
      { id: 'tubular', value: 'Tubular' },
      { id: 'mucoid', value: 'Mucoid' },
      { id: 'papillary', value: 'Papillary' },
      { id: 'medullary', value: 'Medullary' },
    ],
  },
  breastCancerEstrogenReceptor: {
    id: 'breast-cancer-estrogen-receptor',
    questionRef: 'breastCancerEstrogenReceptor',
    title: 'Breast Cancer – Estrogen Receptor Status',
    type: 'radio',
    options: [
      { id: 'positive', value: 'Positive' },
      { id: 'negative', value: 'Negative' },
      { id: 'unknown', value: 'Unknown' },
    ],
  },
  prostateCancerGleasonScore: {
    id: 'prostate-cancer-gleason-score',
    questionRef: 'prostateCancerGleasonScore',
    title: 'Prostate Cancer – Gleason Score',
    type: 'text',
  },
  prostateCancerPsaDiagnosis: {
    id: 'prostate-cancer-psa-diagnosis',
    questionRef: 'prostateCancerPsaDiagnosis',
    title: 'Prostate Cancer – PSA at Diagnosis',
    type: 'number',
  },
  prostateCancerCurrentPsa: {
    id: 'prostate-cancer-current-psa',
    questionRef: 'prostateCancerCurrentPsa',
    title: 'Prostate Cancer – Current PSA',
    type: 'number',
  },
  prostateCancerTreatments: {
    id: 'prostate-cancer-treatments',
    questionRef: 'prostateCancerTreatments',
    title: 'Prostate Cancer – Treatments (select all that apply)',
    type: 'multiselect',
    options: [
      { id: 'surgery', value: 'Surgery' },
      { id: 'chemo', value: 'Chemo' },
      { id: 'radiation', value: 'Radiation' },
      { id: 'active-surveillance', value: 'Active Surveillance' },
      { id: 'watchful-waiting', value: 'Watchful Waiting' },
      { id: 'other', value: 'Other' },
    ],
  },
  prostateCancerDateLastTreated: {
    id: 'prostate-cancer-date-last-treated',
    questionRef: 'prostateCancerDateLastTreated',
    title: 'Prostate Cancer – Date Last Treated (mm/yyyy)',
    type: 'date',
  },
  leukemiaType: {
    id: 'leukemia-type',
    questionRef: 'leukemiaType',
    title: 'Leukemia – Select Type',
    type: 'radio',
    options: [
      { id: 'all', value: 'Acute Lymphoid (ALL)' },
      { id: 'aml', value: 'Acute Myeloid (AML)' },
      { id: 'cll', value: 'Chronic Lymphocytic (CLL)' },
      { id: 'hairy', value: 'Hairy Cell Leukemia' },
      { id: 'cml', value: 'Chronic Myeloid (CML)' },
    ],
  },
  leukemiaAgeAtDiagnosis: {
    id: 'leukemia-age-at-diagnosis',
    questionRef: 'leukemiaAgeAtDiagnosis',
    title: 'Leukemia – Age at Diagnosis',
    type: 'number',
  },
  lymphomaType: {
    id: 'lymphoma-type',
    questionRef: 'lymphomaType',
    title: 'Lymphoma – Type',
    type: 'radio',
    options: [
      { id: 'hodgkin', value: 'Hodgkin’s' },
      { id: 'non-hodgkin', value: 'Non-Hodgkin’s' },
    ],
  },
  lymphomaNonHodgkinsSubtype: {
    id: 'lymphoma-non-hodgkins-subtype',
    questionRef: 'lymphomaNonHodgkinsSubtype',
    title: 'Non-Hodgkin’s – Subtype',
    type: 'select',
    options: [
      { id: 'malt', value: 'MALT Lymphomas' },
      { id: 'maltomas', value: 'Maltomas' },
      {
        id: 'extra-nodal-mzb',
        value: 'Extra Nodal Marginal Zone B-Cell',
      },
      { id: 'follicular', value: 'Follicular' },
      {
        id: 'transformed-follic',
        value: 'Transformed Follicular',
      },
      { id: 'nodal-mzb', value: 'Nodal Marginal Zone B-Cell' },
      { id: 'dlbcl', value: 'Diffuse Large B-Cell' },
      { id: 'burkitt', value: 'Burkitt' },
      { id: 'mantle-cell', value: 'Mantle Cell' },
      { id: 'peripheral-t', value: 'Peripheral T-Cell' },
      {
        id: 'other-high-grade',
        value: 'Other High-Grade Lymphoma',
      },
      { id: 'cutaneous', value: 'Cutaneous Lymphoma' },
      { id: 'mycosis-fungoides', value: 'Mycosis Fungoides' },
      { id: 'sezary', value: 'Sèzary Syndrome' },
      {
        id: 'adult-t-cell',
        value: 'Adult T-Cell Lymphoma/Leukemia',
      },
    ],
  },
  diabetesDateDiagnosed: {
    id: 'diabetes-date-diagnosed',
    questionRef: 'diabetesDateDiagnosed',
    title: 'Diabetes – Date Diagnosed (mm/yyyy)',
    type: 'date',
  },
  diabetesType: {
    id: 'diabetes-type',
    questionRef: 'diabetesType',
    title: 'Diabetes – Type',
    type: 'radio',
    options: [
      { id: 'type-i', value: 'Type I' },
      { id: 'type-ii', value: 'Type II' },
    ],
  },
  diabetesDateLastA1c: {
    id: 'diabetes-date-last-a1c',
    questionRef: 'diabetesDateLastA1c',
    title: 'Date Last A1C Test (mm/yyyy)',
    type: 'date',
  },
  diabetesA1cResult: {
    id: 'diabetes-a1c-result',
    questionRef: 'diabetesA1cResult',
    title: 'A1C Result',
    type: 'number',
  },
  diabetesMedications: {
    id: 'diabetes-medications',
    questionRef: 'diabetesMedications',
    title: 'Diabetes – Medications & Dosage',
    type: 'textarea',
  },
  diabetesComplications: {
    id: 'diabetes-complications',
    questionRef: 'diabetesComplications',
    title: 'Diabetes – Complications (select all that apply)',
    type: 'multiselect',
    options: [
      {
        id: 'retinopathy-background',
        value: 'Retinopathy – Background',
      },
      {
        id: 'retinopathy-proliferative',
        value: 'Retinopathy – Proliferative',
      },
      { id: 'heart-disease', value: 'Heart Disease' },
      { id: 'neuropathy', value: 'Neuropathy' },
      { id: 'kidney-disease', value: 'Kidney Disease' },
      {
        id: 'urine-protein',
        value: 'Urine Protein/Microalbumin',
      },
      { id: 'cerebrovascular', value: 'Cerebrovascular' },
      {
        id: 'peripheral-vascular',
        value: 'Peripheral Vascular Disease',
      },
      { id: 'skin-ulcers', value: 'Skin Ulcers' },
      { id: 'amputations', value: 'Amputations' },
    ],
  },
  diabetesComplicationDetails: {
    id: 'diabetes-complication-details',
    questionRef: 'diabetesComplicationDetails',
    title: 'Diabetes – Complication Dates & Details',
    type: 'textarea',
  },
  mentalDisorders: {
    id: 'mental-disorders',
    questionRef: 'mentalDisorders',
    title: 'Mental/Nervous – Conditions (select all that apply)',
    type: 'multiselect',
    options: [
      { id: 'anxiety', value: 'Anxiety' },
      { id: 'depression', value: 'Depression' },
      { id: 'bipolar', value: 'Bipolar' },
      { id: 'add-adhd', value: 'ADD/ADHD' },
      { id: 'ptsd', value: 'PTSD' },
    ],
  },
  mentalDateDiagnosed: {
    id: 'mental-date-diagnosed',
    questionRef: 'mentalDateDiagnosed',
    title: 'Mental/Nervous – Date Diagnosed (mm/yyyy)',
    type: 'date',
  },
  mentalTreatment: {
    id: 'mental-treatment',
    questionRef: 'mentalTreatment',
    title: 'Mental/Nervous – Medication & Other Treatment',
    type: 'textarea',
  },
  mentalHospitalizations: {
    id: 'mental-hospitalizations',
    questionRef: 'mentalHospitalizations',
    title: 'Any Mental/Nervous Hospitalizations or ER Visits',
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  mentalHospitalizationDetails: {
    id: 'mental-hospitalization-details',
    questionRef: 'mentalHospitalizationDetails',
    title: 'Mental/Nervous – Hospitalization Details',
    type: 'textarea',
  },
  substanceAbuseSubstances: {
    id: 'substance-abuse-substances',
    questionRef: 'substanceAbuseSubstances',
    title: 'Alcohol/Drug Abuse – Substance(s)',
    type: 'text',
  },
  substanceAbuseDateLastUsed: {
    id: 'substance-abuse-date-last-used',
    questionRef: 'substanceAbuseDateLastUsed',
    title: 'Alcohol/Drug Abuse – Date Last Used (mm/yyyy)',
    type: 'date',
  },
  substanceAbuseTreatments: {
    id: 'substance-abuse-treatments',
    questionRef: 'substanceAbuseTreatments',
    title: 'Alcohol/Drug Abuse – Treatments (select all that apply)',
    type: 'multiselect',
    options: [
      { id: 'medication', value: 'Medication' },
      { id: 'hospitalization', value: 'Hospitalization' },
      { id: 'treatment-program', value: 'Treatment Program' },
      { id: 'support-group', value: 'Support Group' },
    ],
  },
  substanceAbuseLastTreatedDetails: {
    id: 'substance-abuse-last-treated-details',
    questionRef: 'substanceAbuseLastTreatedDetails',
    title: 'Date Last Treated & Details',
    type: 'textarea',
  },
  substanceAbuseRelapse: {
    id: 'substance-abuse-relapse',
    questionRef: 'substanceAbuseRelapse',
    title: 'Any Relapse',
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  substanceAbuseComplications: {
    id: 'substance-abuse-complications',
    questionRef: 'substanceAbuseComplications',
    title: 'Any Complications',
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  substanceAbuseComplicationDetails: {
    id: 'substance-abuse-complication-details',
    questionRef: 'substanceAbuseComplicationDetails',
    title: 'Alcohol/Drug Abuse – Relapse or Complication Details',
    type: 'textarea',
  },
  musculoskeletalDiagnosis: {
    id: 'musculoskeletal-diagnosis',
    questionRef: 'musculoskeletalDiagnosis',
    title: 'Musculoskeletal – Diagnosis',
    type: 'text',
  },
  musculoskeletalDateDiagnosed: {
    id: 'musculoskeletal-date-diagnosed',
    questionRef: 'musculoskeletalDateDiagnosed',
    title: 'Musculoskeletal – Date Diagnosed (mm/yyyy)',
    type: 'date',
  },
  musculoskeletalTreatments: {
    id: 'musculoskeletal-treatments',
    questionRef: 'musculoskeletalTreatments',
    title: 'Musculoskeletal – Treatments (select all that apply)',
    type: 'multiselect',
    options: [
      { id: 'medications', value: 'Medications' },
      { id: 'injection', value: 'Injection' },
    ],
  },
  musculoskeletalInjectionType: {
    id: 'musculoskeletal-injection-type',
    questionRef: 'musculoskeletalInjectionType',
    title: 'Injection Type (if applicable)',
    type: 'text',
  },
  musculoskeletalInjectionFrequency: {
    id: 'musculoskeletal-injection-frequency',
    questionRef: 'musculoskeletalInjectionFrequency',
    title: 'Injection Frequency (if applicable)',
    type: 'text',
  },
  musculoskeletalDateLastInjection: {
    id: 'musculoskeletal-date-last-injection',
    questionRef: 'musculoskeletalDateLastInjection',
    title: 'Date of Last Injection (mm/yyyy)',
    type: 'date',
  },
  musculoskeletalPhysicalTherapy: {
    id: 'musculoskeletal-physical-therapy',
    questionRef: 'musculoskeletalPhysicalTherapy',
    title: 'Physical Therapy',
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  musculoskeletalAssistiveDevices: {
    id: 'musculoskeletal-assistive-devices',
    questionRef: 'musculoskeletalAssistiveDevices',
    title: 'Use of Assistive Devices',
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  musculoskeletalFunctionalLimitations: {
    id: 'musculoskeletal-functional-limitations',
    questionRef: 'musculoskeletalFunctionalLimitations',
    title: 'Any Functional Limitations',
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  musculoskeletalSurgeryPlanned: {
    id: 'musculoskeletal-surgery-planned',
    questionRef: 'musculoskeletalSurgeryPlanned',
    title: 'Surgery Recommended or Planned',
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  musculoskeletalDetails: {
    id: 'musculoskeletal-details',
    questionRef: 'musculoskeletalDetails',
    title: 'Musculoskeletal – Details',
    type: 'textarea',
  },
  osteoporosisDateLastBoneDensity: {
    id: 'osteoporosis-date-last-bone-density',
    questionRef: 'osteoporosisDateLastBoneDensity',
    title: 'Osteoporosis – Date of Last Bone Density (mm/yyyy)',
    type: 'date',
  },
  osteoporosisTScores: {
    id: 'osteoporosis-t-scores',
    questionRef: 'osteoporosisTScores',
    title: 'Osteoporosis – T-Scores',
    type: 'text',
  },
  osteoporosisFallsFractures: {
    id: 'osteoporosis-falls-fractures',
    questionRef: 'osteoporosisFallsFractures',
    title: 'Any Falls/Broken Bones/Fractures',
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  osteoporosisFallsDetails: {
    id: 'osteoporosis-falls-details',
    questionRef: 'osteoporosisFallsDetails',
    title: 'If Yes, Date & Location',
    type: 'textarea',
  },
  osteoporosisTreatment: {
    id: 'osteoporosis-treatment',
    questionRef: 'osteoporosisTreatment',
    title: 'Osteoporosis – Treatment',
    type: 'textarea',
  },
  respiratoryDiagnosis: {
    id: 'respiratory-diagnosis',
    questionRef: 'respiratoryDiagnosis',
    title: 'Respiratory/Asthma/COPD/Sleep Apnea – Diagnosis',
    type: 'text',
  },
  respiratoryDateDiagnosed: {
    id: 'respiratory-date-diagnosed',
    questionRef: 'respiratoryDateDiagnosed',
    title: 'Respiratory – Date Diagnosed (mm/yyyy)',
    type: 'date',
  },
  respiratoryTreatment: {
    id: 'respiratory-treatment',
    questionRef: 'respiratoryTreatment',
    title: 'Respiratory – Treatment',
    type: 'textarea',
  },
  respiratoryPriorTobaccoUse: {
    id: 'respiratory-prior-tobacco-use',
    questionRef: 'respiratoryPriorTobaccoUse',
    title: 'Prior Tobacco Use',
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  respiratoryDateLastTobaccoUse: {
    id: 'respiratory-date-last-tobacco-use',
    questionRef: 'respiratoryDateLastTobaccoUse',
    title: 'If Yes, Date Last Used (mm/yyyy)',
    type: 'date',
  },
  respiratoryHospitalizations: {
    id: 'respiratory-hospitalizations',
    questionRef: 'respiratoryHospitalizations',
    title: 'Hospitalizations / ER Visits / Limitations',
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  respiratorySupplementalOxygen: {
    id: 'respiratory-supplemental-oxygen',
    questionRef: 'respiratorySupplementalOxygen',
    title: 'Use of Supplemental Oxygen',
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  respiratoryDetails: {
    id: 'respiratory-details',
    questionRef: 'respiratoryDetails',
    title: 'Respiratory – Details',
    type: 'textarea',
  },
  strokeTiaEvents: {
    id: 'stroke-tia-events',
    questionRef: 'strokeTiaEvents',
    title: 'Stroke/TIA – Events (select all that apply)',
    type: 'multiselect',
    options: [
      { id: 'stroke-single', value: 'Stroke – Single' },
      { id: 'stroke-multiple', value: 'Stroke – Multiple' },
      { id: 'tia-single', value: 'TIA – Single' },
      { id: 'tia-multiple', value: 'TIA – Multiple' },
    ],
  },
  strokeTiaDatesDiagnosed: {
    id: 'stroke-tia-dates-diagnosed',
    questionRef: 'strokeTiaDatesDiagnosed',
    title: 'Stroke/TIA – Date(s) Diagnosed (mm/yyyy)',
    type: 'text',
  },
  strokeTiaTreatment: {
    id: 'stroke-tia-treatment',
    questionRef: 'strokeTiaTreatment',
    title: 'Stroke/TIA – Treatment',
    type: 'textarea',
  },
  strokeTiaResiduals: {
    id: 'stroke-tia-residuals',
    questionRef: 'strokeTiaResiduals',
    title: 'Stroke/TIA – Residuals',
    type: 'textarea',
  },
  otherMedicalImpairments: {
    id: 'other-medical-impairments',
    questionRef: 'otherMedicalImpairments',
    title: 'Other Medical Impairments & Current Medications',
    type: 'table',
    minRows: 1,
    maxRows: 16,
    columns: [
      {
        id: 'impairment',
        title: 'Impairment',
        type: 'text',
        required: true,
        placeholder: 'Enter impairment',
      },
      {
        id: 'treatment',
        title: 'Treatment / Medication / Surgery',
        type: 'text',
        required: true,
        placeholder: 'Enter treatment details',
      },
      {
        id: 'date',
        title: 'Date (mm/yyyy)',
        type: 'text',
        required: true,
        placeholder: 'mm/yyyy',
      },
    ],
  },
  additionalComments: {
    id: 'additional-comments',
    questionRef: 'additionalComments',
    title: 'Additional Comments',
    type: 'textarea',
  },
};
export const assetCareFormDefinition: PolicyFormDefinition = {
  sections: [
    /* ------------------------------------------------------------------ */
    /* 1 ▸ CLIENT INFORMATION                                             */
    /* ------------------------------------------------------------------ */
    {
      id: 'client-info',
      title: 'Client Information',
      subsections: [
        /* -- Demographics & Vitals ------------------------------------- */
        {
          id: 'demographics',
          title: 'Demographics & Vitals',
          questionGroups: [
            {
              id: 'demographics-vitals',
              title: 'Basic Details',
              format: 'grid',
              questions: [
                'clientGender',
                'clientAge',
                'clientHeight',
                'clientWeight',
              ],
            },
          ],
        },

        /* -- Lifestyle / Substance Use --------------------------------- */
        {
          id: 'lifestyle',
          title: 'Lifestyle & Substance Use',
          questionGroups: [
            {
              id: 'substance-use',
              title: 'Products Used (last 12 months)',
              format: 'default',
              questions: [
                'productsUsed',
                'productsUseFrequency',
                'productsUseAmount',
              ],
            },
          ],
        },

        /* -- Current Status / History ---------------------------------- */
        {
          id: 'medical-status',
          title: 'Current Status & History',
          questionGroups: [
            {
              id: 'status-history',
              title: 'Status / Prior Decisions',
              format: 'default',
              questions: [
                'pendingSurgery',
                'pendingSurgeryDetails',
                'previouslyDeclined',
                'socialSecurityDisability',
              ],
            },
          ],
        },
      ],
    },

    /* ------------------------------------------------------------------ */
    /* 2 ▸ CARDIAC / HEART                                                */
    /* ------------------------------------------------------------------ */
    {
      id: 'cardiac',
      title: 'Cardiac / Heart',
      subsections: [
        /* -- General Cardiac ------------------------------------------- */
        {
          id: 'cardiac-general',
          title: 'General Cardiac Information',
          questionGroups: [
            {
              id: 'cardiac-general-info',
              title: 'Diagnosis & History',
              format: 'default',
              questions: [
                'cardiacDiagnosis',
                'cardiacDateDiagnosed',
                'cardiacRecentTestingResults',
                'cardiacCurrentSymptoms',
                'cardiacAdditionalConditions',
                'cardiacDatesDetails',
              ],
            },
          ],
        },

        /* -- Atrial Fibrillation -------------------------------------- */
        {
          id: 'atrial-fibrillation',
          title: 'Atrial Fibrillation',
          questionGroups: [
            {
              id: 'afib',
              title: 'A-Fib Details',
              format: 'default',
              questions: ['afibTreatments', 'afibDetails'],
            },
          ],
        },

        /* -- Coronary Artery Disease ----------------------------------- */
        {
          id: 'coronary-artery-disease',
          title: 'Coronary Artery Disease (CAD)',
          questionGroups: [
            {
              id: 'cad',
              title: 'CAD Details',
              format: 'default',
              questions: [
                'cadTreatments',
                'cadHistoryHeartAttack',
                'cadDetails',
              ],
            },
          ],
        },

        /* -- Valvular Heart Disease ------------------------------------ */
        {
          id: 'valvular-heart-disease',
          title: 'Valvular Heart Disease',
          questionGroups: [
            {
              id: 'vhd',
              title: 'Valvular Details',
              format: 'default',
              questions: ['vhdValves', 'vhdTreatments', 'vhdDetails'],
            },
          ],
        },
      ],
    },

    /* ------------------------------------------------------------------ */
    /* 3 ▸ CANCER                                                         */
    /* ------------------------------------------------------------------ */
    {
      id: 'cancer',
      title: 'Cancer',
      subsections: [
        /* -- General Cancer ------------------------------------------- */
        {
          id: 'cancer-general',
          title: 'General Cancer Information',
          questionGroups: [
            {
              id: 'cancer-general-info',
              title: 'Diagnosis & Treatment',
              format: 'default',
              questions: [
                'cancerDiagnosisLocation',
                'cancerDateDiagnosed',
                'cancerStageGradeType',
                'cancerTumorSize',
                'cancerLymphNodeSpread',
                'cancerTreatments',
                'cancerDateLastTreated',
                'cancerRecurrence',
                'cancerRecurrenceDetails',
              ],
            },
          ],
        },

        /* -- Breast Cancer -------------------------------------------- */
        {
          id: 'breast-cancer',
          title: 'Breast Cancer',
          questionGroups: [
            {
              id: 'breast-cancer-details',
              title: 'Breast Cancer Details',
              format: 'default',
              questions: ['breastCancerType', 'breastCancerEstrogenReceptor'],
            },
          ],
        },

        /* -- Prostate Cancer ------------------------------------------ */
        {
          id: 'prostate-cancer',
          title: 'Prostate Cancer',
          questionGroups: [
            {
              id: 'prostate-cancer-details',
              title: 'Prostate Cancer Details',
              format: 'default',
              questions: [
                'prostateCancerGleasonScore',
                'prostateCancerPsaDiagnosis',
                'prostateCancerCurrentPsa',
                'prostateCancerTreatments',
                'prostateCancerDateLastTreated',
              ],
            },
          ],
        },

        /* -- Leukemia -------------------------------------------------- */
        {
          id: 'leukemia',
          title: 'Leukemia',
          questionGroups: [
            {
              id: 'leukemia-details',
              title: 'Leukemia Details',
              format: 'default',
              questions: ['leukemiaType', 'leukemiaAgeAtDiagnosis'],
            },
          ],
        },

        /* -- Lymphoma -------------------------------------------------- */
        {
          id: 'lymphoma',
          title: 'Lymphoma',
          questionGroups: [
            {
              id: 'lymphoma-details',
              title: 'Lymphoma Details',
              format: 'default',
              questions: ['lymphomaType', 'lymphomaNonHodgkinsSubtype'],
            },
          ],
        },
      ],
    },

    /* ------------------------------------------------------------------ */
    /* 4 ▸ DIABETES                                                      */
    /* ------------------------------------------------------------------ */
    {
      id: 'diabetes',
      title: 'Diabetes',
      subsections: [
        {
          id: 'diabetes-details',
          title: 'Diabetes Details',
          questionGroups: [
            {
              id: 'diabetes-info',
              title: 'Diagnosis & Management',
              format: 'default',
              questions: [
                'diabetesDateDiagnosed',
                'diabetesType',
                'diabetesDateLastA1c',
                'diabetesA1cResult',
                'diabetesMedications',
                'diabetesComplications',
                'diabetesComplicationDetails',
              ],
            },
          ],
        },
      ],
    },

    /* ------------------------------------------------------------------ */
    /* 5 ▸ MENTAL / NERVOUS                                              */
    /* ------------------------------------------------------------------ */
    {
      id: 'mental-nervous',
      title: 'Mental / Nervous',
      subsections: [
        {
          id: 'mental-nervous-details',
          title: 'Mental / Nervous Details',
          questionGroups: [
            {
              id: 'mental-info',
              title: 'Conditions & Treatment',
              format: 'default',
              questions: [
                'mentalDisorders',
                'mentalDateDiagnosed',
                'mentalTreatment',
                'mentalHospitalizations',
                'mentalHospitalizationDetails',
              ],
            },
          ],
        },
      ],
    },

    /* ------------------------------------------------------------------ */
    /* 6 ▸ ALCOHOL / DRUG ABUSE                                          */
    /* ------------------------------------------------------------------ */
    {
      id: 'substance-abuse',
      title: 'Alcohol / Drug Abuse',
      subsections: [
        {
          id: 'substance-abuse-details',
          title: 'Substance Abuse Details',
          questionGroups: [
            {
              id: 'substance-info',
              title: 'Substance Use & Treatment',
              format: 'default',
              questions: [
                'substanceAbuseSubstances',
                'substanceAbuseDateLastUsed',
                'substanceAbuseTreatments',
                'substanceAbuseLastTreatedDetails',
                'substanceAbuseRelapse',
                'substanceAbuseComplications',
                'substanceAbuseComplicationDetails',
              ],
            },
          ],
        },
      ],
    },

    /* ------------------------------------------------------------------ */
    /* 7 ▸ MUSCULOSKELETAL                                               */
    /* ------------------------------------------------------------------ */
    {
      id: 'musculoskeletal',
      title: 'Musculoskeletal',
      subsections: [
        {
          id: 'musculoskeletal-details',
          title: 'Musculoskeletal Details',
          questionGroups: [
            {
              id: 'musculoskeletal-info',
              title: 'Diagnosis & Treatment',
              format: 'default',
              questions: [
                'musculoskeletalDiagnosis',
                'musculoskeletalDateDiagnosed',
                'musculoskeletalTreatments',
                'musculoskeletalInjectionType',
                'musculoskeletalInjectionFrequency',
                'musculoskeletalDateLastInjection',
                'musculoskeletalPhysicalTherapy',
                'musculoskeletalAssistiveDevices',
                'musculoskeletalFunctionalLimitations',
                'musculoskeletalSurgeryPlanned',
                'musculoskeletalDetails',
              ],
            },
          ],
        },
      ],
    },

    /* ------------------------------------------------------------------ */
    /* 8 ▸ OSTEOPOROSIS                                                  */
    /* ------------------------------------------------------------------ */
    {
      id: 'osteoporosis',
      title: 'Osteoporosis',
      subsections: [
        {
          id: 'osteoporosis-details',
          title: 'Osteoporosis Details',
          questionGroups: [
            {
              id: 'osteoporosis-info',
              title: 'Bone Density & Treatment',
              format: 'default',
              questions: [
                'osteoporosisDateLastBoneDensity',
                'osteoporosisTScores',
                'osteoporosisFallsFractures',
                'osteoporosisFallsDetails',
                'osteoporosisTreatment',
              ],
            },
          ],
        },
      ],
    },

    /* ------------------------------------------------------------------ */
    /* 9 ▸ RESPIRATORY                                                   */
    /* ------------------------------------------------------------------ */
    {
      id: 'respiratory',
      title: 'Respiratory / Asthma / COPD / Sleep Apnea',
      subsections: [
        {
          id: 'respiratory-details',
          title: 'Respiratory Details',
          questionGroups: [
            {
              id: 'respiratory-info',
              title: 'Diagnosis & Treatment',
              format: 'default',
              questions: [
                'respiratoryDiagnosis',
                'respiratoryDateDiagnosed',
                'respiratoryTreatment',
                'respiratoryPriorTobaccoUse',
                'respiratoryDateLastTobaccoUse',
                'respiratoryHospitalizations',
                'respiratorySupplementalOxygen',
                'respiratoryDetails',
              ],
            },
          ],
        },
      ],
    },

    /* ------------------------------------------------------------------ */
    /* 10 ▸ STROKE / TIA                                                 */
    /* ------------------------------------------------------------------ */
    {
      id: 'stroke-tia',
      title: 'Stroke / TIA',
      subsections: [
        {
          id: 'stroke-tia-details',
          title: 'Stroke / TIA Details',
          questionGroups: [
            {
              id: 'stroke-tia-info',
              title: 'Events & Treatment',
              format: 'default',
              questions: [
                'strokeTiaEvents',
                'strokeTiaDatesDiagnosed',
                'strokeTiaTreatment',
                'strokeTiaResiduals',
              ],
            },
          ],
        },
      ],
    },

    /* ------------------------------------------------------------------ */
    /* 11 ▸ OTHER MEDICAL IMPAIRMENTS & COMMENTS                          */
    /* ------------------------------------------------------------------ */
    {
      id: 'other-impairments',
      title: 'Other Medical Impairments & Comments',
      subsections: [
        {
          id: 'other-impairments-details',
          title: 'Other Medical Impairments',
          questionGroups: [
            {
              id: 'other-impairments-table',
              title: 'Impairments & Current Medications',
              format: 'default',
              questions: ['otherMedicalImpairments', 'additionalComments'],
            },
          ],
        },
      ],
    },
  ],
  questions: questions,
};
